import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { 
  Grid,
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TablePagination, 
  TableRow, 
  Paper, 
} from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import { TableToolbarGeneracion } from "./TableToolbarGeneracion";
import { TableHeadGeneracion } from "./TableHeadGeneracion";
import { TableRowGeneracion } from "./TableRowGeneracion";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import { FooterTableToolbarGeneracion } from "./FooterTableToolbarGeneracion";
import { generarFacturaAfiliados } from "../../../actions/facturacion/facturasAfiliado";
import { TIPO_COMPROBANTE } from "../../../utils/constants";
import { agregarAfiliadoPropuesta, editarAfiliadoPropuesta, fetchUltimaObservacion, fetchPropuestaFacturacion, modificarObservacionFacturacion, observacionFacturacionLimpiar, propuestaFacturacionLimpiar } from "../../../actions/facturacion/propuestaFacturacion";
import { TablePaginationActions } from "../../compartidos/TablePaginationActions";
import { startAlerta } from "../../../actions/ui/alertas";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  rootTableRow: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
}));

export function GeneracionFacturas() {
  
  const classes = useStyles();
  const dispatch = useDispatch();

  const { items, observacion } = useSelector((state) => state.propuestaFacturacion);
      
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("apellido_nombre");
  const [filteredList, setFilteredList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense/* , setDense */] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [observacionTemp, setObservacionTemp] = React.useState('');

  useEffect(() => {
    dispatch( propuestaFacturacionLimpiar() );
    dispatch( fetchUltimaObservacion(TIPO_COMPROBANTE.FACTURA) );
    dispatch( fetchPropuestaFacturacion() );
    dispatch( observacionFacturacionLimpiar() );
  }, [dispatch]);

  
  useEffect(() => {
    setFilteredList(items);
  }, [items]);
  

  useEffect(() => {
    setObservacionTemp(observacion?.descripcion);
  }, [observacion]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const isSelected = (idAfiliado) => selected.filter(s => s.idAfiliado === idAfiliado).length > 0;

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      if(filteredList.filter(s => !s.importe).length > 0) {
        dispatch( startAlerta("Para generar factura a todos los afiliados, todos los importe deben ser mayor a $0", "error") );
        return;
      }
      const newSelecteds = filteredList.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, afiliado) => {
    if( !afiliado.importe ){
      dispatch( startAlerta("No se puede seleccionar un afiliado con importe 0 para factura", "error") );
    }else{  
      const selectedIndex = selected.indexOf(afiliado);
      let newSelected = [];
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, afiliado);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
          );
      }
      setSelected(newSelected);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const componentRef = useRef();
  
  const handleConfirmarGenerar = () => {
    if(!observacion || observacionTemp !== observacion?.descripcion)
      dispatch( modificarObservacionFacturacion(JSON.stringify(selected), TIPO_COMPROBANTE.FACTURA, observacionTemp, selected, setSelected([])) );
    else
      dispatch( generarFacturaAfiliados(JSON.stringify(selected), TIPO_COMPROBANTE.FACTURA, observacion.idObservacion, selected, setSelected([])) );

    setOpen(false);
  }

  const handleSearch = (idCategoria) => {
    if(idCategoria===0)
      setFilteredList( items );
    else
      setFilteredList( items.filter(x => x.idTipoAfiliacion === idCategoria) );
    setSelected([]);
  }

  const handleAddPropuestaAfiliado = (afiliado) => {
    if(items.filter(s => s.cuil === afiliado.cuil).length === 0)
      dispatch ( agregarAfiliadoPropuesta(afiliado.id_afiliado) );
    else
      dispatch( startAlerta("El afiliado que desea buscar ya tiene una propuesta generada.", "error") );
  }

  const handleEditPropuestaAfiliado = (afiliado, cuota, reImputacion, periodo) => {
    dispatch ( editarAfiliadoPropuesta(afiliado.cuil, cuota, isNaN(parseInt(reImputacion)) ? null : reImputacion, isNaN(parseInt(periodo)) ? 0 : periodo) );
  }

  return (      
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableToolbarGeneracion 
          rows={items}
          setFilteredList={setFilteredList}
          handleSearch={handleSearch}
          handleAddPropuestaAfiliado={handleAddPropuestaAfiliado}
          handleEditPropuestaAfiliado={handleEditPropuestaAfiliado}
        />
        <TableContainer component={Paper}>
          <Table
            ref={componentRef}
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            aria-label="collapsible table"
          >
            <TableHeadGeneracion
              classes={classes}
              numSelected={selected.length}
              {...{ order, orderBy }}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={filteredList.length}
            />
            <TableBody>
              {stableSort(filteredList, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.idAfiliado);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <React.Fragment key={row.idAfiliado}>
                      <TableRowGeneracion 
                        row={row}
                        labelId={labelId}
                        handleClick={handleClick}
                        isItemSelected={isItemSelected}
                        handleEditPropuestaAfiliado={handleEditPropuestaAfiliado}
                      />
                    </React.Fragment>
                  );
                })}
              {filteredList.length === 0 && (
                <TableRow style={{ height: 50 }}>
                  <TableCell colSpan={8} style={{textAlign: '-webkit-center'}}> Sin Registros</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredList.length}
          {...{ rowsPerPage, page }}
          labelRowsPerPage='Registros por página'
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
        <Grid item container>
            <Grid item xs={4}></Grid>
            <Grid item xs={4}>
                {selected.length > 0&&
                    <FooterTableToolbarGeneracion
                      numSelected={selected.length}
                      handleSubmit={() => setOpen(true)}
                    />
                }
            </Grid>
            <Grid item xs={4}></Grid>
        </Grid>
        
        {open && 
          <AlertFinalizadoStepper
            open={open}
            esFactura={true}
            pregunta={"Generación de facturas"}
            dialogText={`Se van a generar facturas para ${selected.length} afiliados. Esta seguro?`}
            buttonCancel={"Cancelar"}
            buttonSubmit={"Continuar"}
            showTextarea={true}
            textBoxWithContent={true}
            value={observacionTemp}
            setObservacion={setObservacionTemp}
            handleClose={() => setOpen(false)}
            handleSend={handleConfirmarGenerar}
          />
        }
      </Paper>
    </div>
  );
}
